/**
 * Vocabulário compartilhado das operações em lote.
 *
 * ⚠️ Este arquivo já teve 35 exports: rótulos de status, opções de filtro, formatação de duração,
 * quebra de valores. Todos serviam à tela `/lotes-financeiros`, que foi cortada — o rastro de lote
 * passou a morar no detalhe do ajuste e a fila de leitura numa faixa no topo da lista. Sobrou o
 * que esses dois lugares realmente usam.
 *
 * Um mapa de rótulo por tela é como se produz "Com ciência" numa e "Ciência dada" noutra; por isso
 * o que sobreviveu continua centralizado aqui e não copiado nos componentes.
 */

/** Simulação: a operação não moveu dinheiro nenhum. */
export const DRY_RUN_MODE = 'dry_run'

export const PENDING_REVIEW_STATUS = 'pending'
export const ACKNOWLEDGED_REVIEW_STATUS = 'acknowledged'
export const QUESTIONED_REVIEW_STATUS = 'questioned'

/**
 * Questionar exige explicação: um "ok" não diz ao autor da operação o que conferir. O backend
 * valida o mesmo mínimo — divergir aqui só adiantaria a recusa para depois do envio.
 */
export const REVIEW_NOTES_MIN_LENGTH = 20

/**
 * Operação DETECTADA: ninguém a abriu. O observer viu escrita em massa fora de um contexto
 * declarado e criou a cabeça sozinho, com o stack trace da origem. É o caso Kauê sendo pego na
 * hora em vez de dois meses depois — por isso a UI a destaca das demais.
 */
export const DETECTED_ORIGIN = 'detected'

const ORIGIN_LABELS = {
  command: 'Comando',
  job: 'Rotina automática',
  http: 'Requisição',
  migration: 'Migração',
  retroactive: 'Retroativa',
  [DETECTED_ORIGIN]: 'Detectada',
}

// Detectada em vermelho: é a única origem que denuncia um problema de processo, e não apenas
// descreve por onde a operação entrou.
const ORIGIN_VARIANTS = {
  [DETECTED_ORIGIN]: 'light-danger',
}

/** Valor desconhecido devolve o próprio valor, nunca string vazia: some sem dizer que sumiu. */
const fromMap = (map, value, fallback) => (
  value != null && map[value] !== undefined ? map[value] : fallback
)

export const batchOriginLabel = value => fromMap(ORIGIN_LABELS, value, value || 'Não informada')
export const batchOriginVariant = value => fromMap(ORIGIN_VARIANTS, value, 'light-secondary')
